import { GoogleLogo, MicrosoftLogo } from "@logos";
import type { OAuthProvider } from "@stores";

interface SsoProviderPresentation {
    provider: OAuthProvider;
    name: string;
    logo: typeof GoogleLogo;
}

export const SSO_PROVIDERS: SsoProviderPresentation[] = [
    { provider: `google`, name: `Google`, logo: GoogleLogo },
    { provider: `microsoft`, name: `Microsoft`, logo: MicrosoftLogo }
];

export const getSsoProviderName = (provider: OAuthProvider): string =>
    SSO_PROVIDERS.find(ssoProvider => ssoProvider.provider === provider)?.name ?? provider;
